import { useMutation } from '@apollo/client';
import { blinkConstants } from '@thoughtspot/blink-constants';
import { useEmbedContext } from '@thoughtspot/blink-context';
import { DeleteBannerConfigDocument, InvalidateUsersDocument, SetBannerConfigDocument, useGetBannerConfigQuery as _useGetBannerConfigQuery, useGetUserAccessibleOrgsLazyQuery as _useGetUserAccessibleOrgsLazyQuery, useGetUserAccessibleOrgsQuery as _useGetUserAccessibleOrgsQuery, useSwitchOrgMutation as _useSwitchOrgMutation, } from '../generated/graphql-types';
export const useSwitchOrgMutation = (onComplete, onError, orgId) => {
    const { dispatchEmbedEvent } = useEmbedContext();
    return _useSwitchOrgMutation({
        variables: {
            orgId,
        },
        update: (cache, result) => {
            dispatchEmbedEvent(blinkConstants.embedEvents.OrgSwitched, {
                orgId,
                result,
            });
            onComplete(result?.data.Session__switchOrg);
        },
        onError: (error) => {
            onError(error);
        },
    });
};
export const useGetUserAccessibleOrgsQuery = () => {
    const { data, error, loading, refetch } = _useGetUserAccessibleOrgsQuery();
    return {
        error,
        loading,
        data: data?.getUserAccessibleOrgs,
        refetch,
    };
};
export const useInvalidateUsersMutation = () => {
    const [_invalidateUsers, { data: result, error, loading }] = useMutation(InvalidateUsersDocument);
    return {
        data: result?.Session__invalidateUsers,
        error,
        loading,
        invalidateUsers: (ids, isAllOrgContext) => _invalidateUsers({
            variables: {
                ids,
                isAllOrgContext,
            },
        }),
    };
};
export const useGetUserAccessibleOrgsLazyQuery = (view_mode = '') => {
    const [getUserAccessibleOrgsLazy, { data, error, loading },] = _useGetUserAccessibleOrgsLazyQuery({
        variables: {
            viewMode: view_mode,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getUserAccessibleOrgs,
        getUserAccessibleOrgsLazy,
    };
};
export const useGetBannerConfig = (level, fetchPolicy = 'cache-first') => {
    const { data, error, loading, refetch } = _useGetBannerConfigQuery({
        variables: {
            level,
        },
        fetchPolicy,
    });
    return {
        data: data?.getBannerConfig?.banner,
        error,
        loading,
        refetch,
    };
};
export const useSetBannerConfig = () => {
    const [setBannerConfig, { data, error, loading }] = useMutation(SetBannerConfigDocument);
    return {
        data: data?.Session__setBannerConfig,
        error,
        loading,
        setBannerConfig: (level, bannerData) => setBannerConfig({
            variables: {
                level,
                bannerData,
            },
        }),
    };
};
export const useDeleteBannerConfig = () => {
    const [deleteBannerConfig, { data, error, loading }] = useMutation(DeleteBannerConfigDocument);
    return {
        data: data?.Session__deleteBannerConfig,
        error,
        loading,
        deleteBannerConfig: (level) => deleteBannerConfig({
            variables: { level },
        }),
    };
};
//# sourceMappingURL=session-service.js.map